var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M4.5 21.5q-.824 0-1.413-.587A1.93 1.93 0 0 1 2.5 19.5v-15q0-.824.587-1.413A1.93 1.93 0 0 1 4.5 2.5h15q.824 0 1.413.587.587.588.587 1.413v15q0 .824-.587 1.413a1.93 1.93 0 0 1-1.413.587z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M4.5 19.5h15v-15h-15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2zm5-.75h5v-1.5h-5zm0-2.5h5v-1.5h-5zm1.1-3.8 1.4-1.4 1.4 1.4 1.05-1.05-1.4-1.45 1.4-1.4L16.9 6l-1.4 1.4L14.1 6l-1.05 1.05 1.4 1.4-1.4 1.45zM6.25 9.2h5V7.7h-5z"
}))));
export default SvgIconCalc;